import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_frantiescoporto.png",
      alt: "Estratégias Frantiesco Porto",
    },
    title: "Replique os trades de um trader profissional",

    // String ou array de strings
    text: "Frantiesco tem feito mais de 100% de rentabilidade a cada 12 meses de forma pública para que todos conheçam e vejam seus resultados e isso chamou a atenção de diversos players do mercado.",
    testimonial: {
      text: "Meu objetivo é crescer o meu patrimônio e de meus clientes sem pressa e sem riscos desnecessários",
      author: {
        name: "Frantiesco Porto",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "Estratégias Frantiesco Porto",
    heading: "6 anos de experiência em um clique",
    subtitle:
      "Você pode repetir em sua conta exatamente os mesmos resultados de um trader consistente e lucrativo ao longo do tempo.",
  },

  cta: {
    title: "Vamos construir juntos nosso patrimônio?",
    subtitle: "Ative agora mesmo a extensão Frantiesco Trader",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Eu era escravo do trabalho.",
    col1: [
      "Vivia com medo de perder o emprego e qualquer possibilidade de eu ganhar mais dinheiro vinha apenas de trabalhar mais ainda...",
      "E passar mais tempo longe de casa e da família.",
      "Sempre busquei algo com o qual eu tivesse uma chance real de dar tranquilidade financeira e conforto total à minha família. E finalmente achei isso no Day Trade.",
    ],
    col2: [
      "Como você e eu sabemos, é no Day Trade que mora a liberdade.",
      "E após 4 anos fazendo Trades, desenvolvi um combo de operacionais sólidos + mentalidade correta para lucrar na Bolsa com riscos baixíssimos, e nos últimos 2 anos venho tendo resultados incríveis e cada vez melhores, otimizando ainda mais meu operacional.",
    ],
  },

  stats: {
    title: "Números das minhas estratégias",
    subtitle:
      "Eu opero essas 3 estratégias desde 2019 mas elas estão em constante evolução sempre",
    data: [
      {
        value: "4",
        description: "Anos de histórico",
      },
      {
        value: "100%",
        description: "De rentabilidade média ao ano",
      },
      {
        value: "2",
        description: "Anos rodando em conta real com resultados públicos",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por quê utilizar os nossos robôs",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      {
        icon: iconsSet.refresh,
        title: "Atualização",
        description:
          "Frantiesco está sempre estudando e evoluindo, buscando cada vez mais otimizar suas estratégias tornando-as cada vez menos arriscadas e mais lucrativas.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente no computador para realizar suas operações. Escolha suas estratégias e deixe que a plataforma opere por você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description:
          "Muitas vezes agimos de maneira irracional e impulsiva em nossos investimentos. Com as estratégias automatizadas você não terá esse problema!",
      },
    ],
  },

  testimonials: [
    {
      text: "O Frantiesco é um dos poucos traders que é realmente vencedor no mercado e que fala a verdade.",
      author: "Lucas Nery",
      job: "Especialista em Investimentos",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "O Frantiesco só foca em algo que vá lhe trazer retorno financeiro, se ele se dedica a alguma coisa, isso vai trazer retorno.",
      author: "Andrew M. Schimitz",
      job: "Trader",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão",
  },
};
